<script setup lang="ts">
import {onMounted, onUnmounted, ref} from "vue";
import SpinWheelPopup from "../../SpinWheelPopup/SpinWheelPopup.vue";

const spinPopup = ref<InstanceType<typeof SpinWheelPopup> | null>(null);

function handleSpinClick() {
  spinPopup.value?.open();
}

function handleOpenSpinEvent() {
  spinPopup.value?.open();
}

onMounted(() => {
  if (typeof window !== "undefined") {
    window.addEventListener("open-spin-popup", handleOpenSpinEvent as EventListener);
  }
});

onUnmounted(() => {
  if (typeof window !== "undefined") {
    window.removeEventListener("open-spin-popup", handleOpenSpinEvent as EventListener);
  }
});
</script>

<template>
  <footer c2c-0 class="footer">
    <div c2c-1 class="footer-container">

      <!-- Column 1 -->
      <div c2c-2 class="footer-col">
        <h3>About Us</h3>
        <ul>
          <li><a href="/about-us">About Team Banner Sports</a></li>
          <li><a href="/contact-us">Contact Us</a></li>
          <li><a href="/terms-of-service">Terms of Service</a></li>
          <li><a href="/privacy-policy">Privacy Policy</a></li>
        </ul>
      </div>

      <!-- Column 2 -->
      <div c2c-3 class="footer-col">
        <h3>Customer Support</h3>
        <ul>
          <li><a href="/frequently-asked-questions">FAQs</a></li>
          <li><a href="/order-guide">Order Guide</a></li>
        </ul>

        <h3 class="mt-24">Products & Services</h3>
        <ul>
          <li><a href="/products-services/team-banners">Team Banners</a></li>
          <li><a href="/products-services/online-design-tool">Online Design Tool</a></li>
        </ul>
      </div>

      <!-- Column 3 -->
      <div c2c-4 class="footer-col">
        <h3>Contact</h3>
        <p c2c-5 class="contact-text">
          💬 We’re available 24/7 – Reach out anytime.
        </p>

        <p>
          📩 Email:
          <a href="mailto:orders@teambannersports.com">
            orders@teambannersports.com
          </a>
        </p>

        <div c2c-6 class="social-row">
          <span>Follow us:</span>
          <a c2c-7 class="social" href="https://www.facebook.com/teambannersports" target="_blank">F</a>
          <a c2c-8 class="social" href="https://www.instagram.com/teambannersports/" target="_blank">I</a>
        </div>

        <!-- Spin Button -->
        <button c2c-9 class="spin-btn" @click="handleSpinClick">
          🎁 Spin Now & Save
        </button>
      </div>

    </div>

    <div c2c-10 class="footer-bottom">
      © 2026 Team Banner Sports. All rights reserved.
    </div>
  </footer>

  <SpinWheelPopup :show-on-load="true"
                  :hide-after-win="false"
                  :lock-after-win="false"
                  storage-key="tbs_spin_popup_v1"
                  ref="spinPopup">
    <template #disclaimer>
      3 free spins per day. Coupons valid for 24h. Terms apply.
    </template>
  </SpinWheelPopup>
</template>

<style scoped>
.footer {
  background: #0f1f3d;
  color: #ffffff;
  padding-top: 60px;
  font-size: 14px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.footer-col h3 {
  font-size: 16px;
  margin-bottom: 14px;
  font-weight: 600;
}

.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-col li {
  margin-bottom: 8px;
}

.footer-col a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: 0.2s;
}

.footer-col a:hover {
  color: #ffffff;
}

.contact-text {
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.85);
}

.social-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.social {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: bold;
}

.social:hover {
  border-color: #ffffff;
}

.spin-btn {
  margin-top: 20px;
  background: #e53935;
  color: #ffffff;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: 0.2s;
}

.spin-btn:hover {
  background: #c62828;
}

.footer-bottom {
  text-align: center;
  padding: 16px;
  background: #0b172e;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.mt-24 {
  margin-top: 24px;
}
</style>
<style lang="scss" scoped></style>